var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "itemTitle": "게시판",
            "tabActive": "기본게시판",
            "bg": "/images/test.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v("게시판")];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first page-section--last",
    attrs: {
      "titWrapClass": "text-center"
    }
  }, [_c('router-view', _vm._b({
    attrs: {
      "name": "board",
      "code": "board-default",
      "skin": "board-default",
      "hide-write-button": ""
    }
  }, 'router-view', {
    category: _vm.category
  }, false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }